(function (angular) {
    'use strict';

    angular.module('shared')

    /**
     *
     */
     .directive('cookies', [function() {

        var controllerFn = ['$scope', '$cookies',
            function($scope, $cookies) {
               $scope.cookie = $cookies.get("cookiesAcceptance");
               $scope.ok = function(){
                    var now = new Date();
                    var exp = new Date(now.getFullYear()+10, now.getMonth(), now.getDate());         
                    $cookies.put("cookiesAcceptance", true, { expires: exp });
                    $scope.cookie = true;
               };
            }

        ];

        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/footer/directive.cookies.html',
            controller: controllerFn
        };
    }]);
})(window.angular);
